module.exports = __webpack_public_path__ + "img/leader-board.92e9aa75.svg";